import React from 'react'
import PropTypes from 'prop-types'
import { EventsPageTemplate } from '../../templates/events-page'
import { HTMLContent } from '../../components/Content'

const EventsPagePreview = ({ entry, getAsset }) => {
  const data = entry.getIn(['data']).toJS()
  
  if (data) {
    return (
      <EventsPageTemplate
        backgroundimage={getAsset(data.backgroundimage)}
        // events={{
        //   name: entry.getIn(['data', 'events', 'name']),
        //   date: entry.getIn(['data', 'events', 'date']),
        //   time: entry.getIn(['data', 'events', 'time']),
        //   image: getAsset(entry.getIn(['data', 'events', 'image'])),
        //   description: entry.getIn(['data', 'events', 'description']),
        // }}
        events={data.events}
        // image={getAsset(entry.getIn(['data', 'image']))}
        contentComponent={HTMLContent}
      />
    )
  } else {
    return <div>Loading...</div>
  }
}

EventsPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
  contentComponent: PropTypes.func,
}

export default EventsPagePreview
